/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Avatar_FallbackInputs */

const id_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const ms_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const da_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const de_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const en_us2_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const es_es2_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const es_mx2_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const fil_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const fr_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const it_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const hu_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const nl_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const no_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const pl_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awatar`)
};

const pt_br2_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`avatar`)
};

const pt_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const ro_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const fi_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const sv_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const vi_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh đại diện`)
};

const tr_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const cs_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const bg_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аватар`)
};

const ru_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аватар`)
};

const uk_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аватар`)
};

const ar_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صورة رمزية`)
};

const hi_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवतार`)
};

const th_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รูปโปรไฟล์`)
};

const ja_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アバター`)
};

const zh_cn2_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`头像`)
};

const zh_hant1_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大頭貼`)
};

const ko_profile_avatar_fallback = /** @type {(inputs: Profile_Avatar_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아바타`)
};

/**
* | output |
* | --- |
* | "Avatar" |
*
* @param {Profile_Avatar_FallbackInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_avatar_fallback = /** @type {((inputs?: Profile_Avatar_FallbackInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Avatar_FallbackInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_avatar_fallback(inputs)
	if (locale === "ms") return ms_profile_avatar_fallback(inputs)
	if (locale === "da") return da_profile_avatar_fallback(inputs)
	if (locale === "de") return de_profile_avatar_fallback(inputs)
	if (locale === "en-US") return en_us2_profile_avatar_fallback(inputs)
	if (locale === "es-ES") return es_es2_profile_avatar_fallback(inputs)
	if (locale === "es-MX") return es_mx2_profile_avatar_fallback(inputs)
	if (locale === "fil") return fil_profile_avatar_fallback(inputs)
	if (locale === "fr") return fr_profile_avatar_fallback(inputs)
	if (locale === "it") return it_profile_avatar_fallback(inputs)
	if (locale === "hu") return hu_profile_avatar_fallback(inputs)
	if (locale === "nl") return nl_profile_avatar_fallback(inputs)
	if (locale === "no") return no_profile_avatar_fallback(inputs)
	if (locale === "pl") return pl_profile_avatar_fallback(inputs)
	if (locale === "pt-BR") return pt_br2_profile_avatar_fallback(inputs)
	if (locale === "pt") return pt_profile_avatar_fallback(inputs)
	if (locale === "ro") return ro_profile_avatar_fallback(inputs)
	if (locale === "fi") return fi_profile_avatar_fallback(inputs)
	if (locale === "sv") return sv_profile_avatar_fallback(inputs)
	if (locale === "vi") return vi_profile_avatar_fallback(inputs)
	if (locale === "tr") return tr_profile_avatar_fallback(inputs)
	if (locale === "cs") return cs_profile_avatar_fallback(inputs)
	if (locale === "bg") return bg_profile_avatar_fallback(inputs)
	if (locale === "ru") return ru_profile_avatar_fallback(inputs)
	if (locale === "uk") return uk_profile_avatar_fallback(inputs)
	if (locale === "ar") return ar_profile_avatar_fallback(inputs)
	if (locale === "hi") return hi_profile_avatar_fallback(inputs)
	if (locale === "th") return th_profile_avatar_fallback(inputs)
	if (locale === "ja") return ja_profile_avatar_fallback(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_avatar_fallback(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_avatar_fallback(inputs)
	return ko_profile_avatar_fallback(inputs)
});
export { profile_avatar_fallback as "profile.avatar.fallback" }